module.exports = __webpack_public_path__ + "static/media/ice30.38d4bb48.webp";